import {Node} from "../../../model/Graph";
import {ValueObjectMetadata} from "./get-vo-metadata";

export const getSchemaDefinitionId = (vo: Node, voMeta: ValueObjectMetadata): string => {
  // @TODO implement function
  return '';
}
